import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import pageBg from "../../../assets/images/intelligence-solution/page-bg.png";
import CustomBreadcrumb from "../../../components/customBreadcrumb/CustomBreadcrumb";
import { BASE_URL_SLT_MOBITEL } from "../../../const/URL";
import { IIntelligenceSolutionBusinessPageItem } from "../../../interfaces/IntelligenceSolutionBusinessPageItem";
import { IRootState } from "../../../store/configureStore";
import styles from "./IntelligenceSolutionItem.module.scss";

const EnterpriseItem = () => {
  const location: any = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  const [data, setData] = useState<
    IIntelligenceSolutionBusinessPageItem | undefined
  >();
  const { businessPageContent, smeBusinessPageContent } = useSelector(
    ({ intelligenceSolution }: IRootState) => ({
      businessPageContent: intelligenceSolution.businessPageContent,
      smeBusinessPageContent: intelligenceSolution.smeBusinessPageContent,
    })
  );

  useEffect(() => {
    const nid: string = location.state?.nid;
    const pageContent =
      params.type === "enterprise"
        ? businessPageContent
        : smeBusinessPageContent;

    const data: IIntelligenceSolutionBusinessPageItem | undefined =
      pageContent.find((item) => item.nid === nid);
    setData(data);
  }, [location, businessPageContent, smeBusinessPageContent, params]);

  return (
    <div className="page-containerV2">
      <Row
        style={{
          backgroundImage: `url(${pageBg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
        className="h-100 rounded"
      >
        <Col>
          {data && (
            <>
              <Row
                style={{
                  backgroundColor: "#C4D9FF",
                }}
                className="rounded-top"
              >
                <Col className="ps-4 mt-3">
                  <CustomBreadcrumb
                    className="mt-2"
                    items={[
                      {
                        path: "/intelligenceSolution/enterprise",
                        title: "SLT Intelligence Solution",
                      },
                      {
                        path: `/intelligenceSolution/enterprise/${data.title}`,
                        title: data.title,
                      },
                    ]}
                  />
                  <Row>
                    <Col
                      className={[styles.title, "mt-1 mb-2"].join(" ")}
                      style={{ color: "black" }}
                    >
                      <Row>
                        <Col className="col-auto">
                          <FontAwesomeIcon
                            icon={faArrowLeft}
                            className="nav-icon pointer"
                            onClick={() => {
                              navigate(-1);
                            }}
                          />
                        </Col>
                        <Col>
                          <div
                            dangerouslySetInnerHTML={{ __html: data.title }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col className={styles.body}>
                      <div dangerouslySetInnerHTML={{ __html: data.body }} />
                    </Col>
                  </Row>
                </Col>
                <Col className="col-auto">
                  <img
                    className="img-fluid"
                    src={BASE_URL_SLT_MOBITEL + data.field_bl_banner_image}
                    alt={data.title}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="pt-5 ps-4">
                  <div
                    className={styles.products}
                    dangerouslySetInnerHTML={{
                      __html: data.field_select_business_products
                        .replaceAll('href="', 'href="' + BASE_URL_SLT_MOBITEL)
                        .replaceAll(
                          'hreflang="en"',
                          'target="_blank" hreflang="en"'
                        ),
                    }}
                  />
                </Col>
              </Row>
            </>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default EnterpriseItem;
